import { useCallback, useState } from 'react';
import { UserRoles } from '@equifinance/shared';
import useApplicationApi from '../api/useApplicationApi';
import { InternalUser } from '../contexts';

export const useUsersByPermissionTypes = (permissionType: UserRoles) => {
  const [internalUsers, setInternalUsers] = useState<InternalUser[]>([]);
  const { getInternalUsers } = useApplicationApi();

  const fetchInternalUsers = useCallback(async () => {
    const result = await getInternalUsers(permissionType);
    setInternalUsers(result);
  }, []);

  return {
    internalUsers,
    setInternalUsers,
    fetchInternalUsers,
  };
};
